import { resolvePath, useLocation } from 'react-router-dom';

export const useIsPage = (appRoute: string) => {
  const location = useLocation();
  return location.pathname === resolvePath(appRoute).pathname;
};
